"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_MOUSE_MOVE_WAITING = exports.PIPELINE_REPORT_UPGRADE_SUBTITLE_CREATOR = exports.PIPELINE_REPORT_UPGRADE_SUBTITLE_ADMIN = exports.UPGRADE_HEADING = void 0;
exports.UPGRADE_HEADING = "Get access to everything";
exports.PIPELINE_REPORT_UPGRADE_SUBTITLE_ADMIN = "Upgrade now to get more than four months of historical data";
exports.PIPELINE_REPORT_UPGRADE_SUBTITLE_CREATOR = "Talk to your admin to upgrade and get more than four months of historical data";
exports.MAX_MOUSE_MOVE_WAITING = 100;
